module.exports = "/build/images/icons-public.0ae63d15.svg";